import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import moment from 'moment';
import { Today } from '@material-ui/icons';
import MomentUtils from '@date-io/moment';
import { globalPutService } from '../../../globalServices';
import checkApiStatus from '../../../utils';
import { useSnackbar } from 'notistack';
import { PageLoader } from '../../../shared_elements';

export default function BulkStatusChangesDialog({ bulkUpdateIds, bulkUpdateStatus, statusChangeModal, ontoggle,getResponseBack }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading,setLoading]=useState(false);
    const [error,setError]=useState({});
    const [selectedStatus,setSelectedStatus]=useState({label:'',value:null});
    const [paidDate,setPaidDate]=useState(moment(Today).format(backendDateFormat));
    const currentStatus = bulkUpdateStatus[0];
    const invoiceStatus = [{ label: 'Sent', value: 2 }, { label: 'Paid', value: 3 }];
    const updatedInvoiceStatus=currentStatus===2?invoiceStatus.filter(optionItem=>optionItem.value!==currentStatus):invoiceStatus;
    const onStatusSelect = (event,value) => {
        setSelectedStatus(value);
    }
    const onDateChange = (date) => {
            setPaidDate(moment(date).format(backendDateFormat));
        };
    const onSaveChanges = () => {  
            let validationInputs={
                selectedStatus:selectedStatus?.value?"":'Please select Invoice Status',
                paidDate:selectedStatus?.value===3? moment(paidDate).isValid()&& moment(paidDate)!==null?"":'Please select a valid Payment Date':""

            }
            if(Object.keys(validationInputs).every(k=>{return validationInputs[k]===""})){
            let payload={
            status: selectedStatus?.value,
            ids:bulkUpdateIds.map(item=>item?.id),
            payment_date:selectedStatus?.value===3?paidDate:null
            }
            setLoading(true);
            globalPutService(`contracts/bulk-invoice-status/`,payload)
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        getResponseBack();
                        ontoggle();
                        enqueueSnackbar(response.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                });
        }
        else{
            setError(validationInputs);
        }

    }

    return (
        <>
        <Dialog open={statusChangeModal}
            className='lease-management-modal'
            maxWidth='md'>
            <DialogTitle>Changes Invoice Status</DialogTitle>
            <DialogContent dividers='true' style={{ width: '400px' }}>
                <Autocomplete
                    style={{ marginTop: '16px' }}
                    options={updatedInvoiceStatus}
                    getOptionLabel={option => option?.label}
                    // value={selectedStatus}
                    id="major_assembly"
                    disableClearable={true}
                    onChange={onStatusSelect}
                    onFocus={()=>setError({...error,selectedStatus:''})}
                    renderInput={params => <TextField required {...params} label="Invoice Status" placeholder="Select Status" InputLabelProps={{ shrink: true }} variant="outlined" error={error?.selectedStatus} helperText={error?.selectedStatus} />}
                />
                {selectedStatus?.value === 3 ?
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            placeholder='DD-MM-YYYY'
                            style={{ marginTop: '16px' }}
                            inputVariant="outlined"
                            variant='outlined'
                            margin="none"
                            id="date"
                            required
                            label="Payment Date"
                            value={paidDate}
                            onChange={onDateChange}
                            format={fieldDateFormat}
                            onFocus={()=>setError({...error,paidDate:''})}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            helperText={error?.paidDate}
                            error={error?.paidDate}
                            disableFuture
                        />
                    </MuiPickersUtilsProvider>
                    : null}
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="outlined" color="primary" onClick={ontoggle}>
                    Cancel
                </Button>
                <Button size='small' variant="contained" color="primary" onClick={onSaveChanges} >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
            {isLoading?<PageLoader/>:null}
        </>
    )
}